/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import {
	Component,
	OnInit,
	Input,
	AfterViewInit,
	ChangeDetectionStrategy,
	Inject,
	PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from '../../../../core/service/config.service';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { MatDialog } from '@angular/material/dialog';
import { WishlistService } from '../../../../core/wishlist/wishlist.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-vendors-carousel',
	templateUrl: './vendors-carousel.component.html',
	styleUrls: ['./vendors-carousel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class VendorsCarouselComponent implements OnInit, AfterViewInit {

	public config: SwiperConfigInterface = {};

	public imagePath: string;
	public currentRate = 2;
	public discountPrice = 20;
	public fiftyPercent = 50;

	public currentUser: any;
	public subscriptions = [];


	constructor(
		public dialog: MatDialog,
		public listSandbox: ListsSandbox,
		public snackBar: MatSnackBar,
		private configService: ConfigService,
		private wishlistService: WishlistService,
		@Inject(PLATFORM_ID) private platformId: Object,
		private router: Router
	) { }

	ngOnInit() {
		this.imagePath = this.configService.getImageUrl();
		this.getFeaturedList();
	}

	ngAfterViewInit() {

		this.config = {
			observer: true,
			slidesPerView: 4,
			spaceBetween: 30,
			keyboard: true,

			navigation: true,
			pagination: false,
			grabCursor: false,
			autoplay: false,
			speed: 900,
			effect: 'slide',
			loop:true,
			breakpoints: {
			  510: {
				slidesPerView: 1
			  },
			  850: {
				slidesPerView: 2
			  },
			  1100: {
				slidesPerView: 3
			  },
			  1280: {
				slidesPerView: 4
			  },
			  1300: {
				slidesPerView: 4
			  },
			  1500: {
				slidesPerView: 4
			  }
			}
		  };
	}

	public addToWishList(vendor) {
		let currentUser: any;
		if (isPlatformBrowser(this.platformId)) {
			currentUser = JSON.parse(localStorage.getItem('storeUser'));
		}
		if (currentUser) {
			console.log(" ******* vendor ***** ", vendor);
			if (vendor.wishListStatus == 0) {
				vendor.wishListStatus = 1;
				this.subscriptions.push(this.wishlistService.addVendorWishlist({
					vendorId: vendor.vendorId
				}).subscribe((response) => {
					vendor.wishlistId = response.data.id;
					this.snackBar.open(response.message, '×', {
						panelClass: 'success',
						verticalPosition: 'top',
						horizontalPosition: 'right',
						duration: 3000
					});
				}, err => {

				}));
			} else {
				vendor.wishListStatus = 0;
				this.subscriptions.push(this.wishlistService.deleteVendorWishlist({
					id: vendor.wishlistId
				}).subscribe((response) => {
					this.snackBar.open(response.message, '×', {
						panelClass: 'success',
						verticalPosition: 'top',
						horizontalPosition: 'right',
						duration: 3000
					});
				}, err => {
		
				}));
			}

		} else {
			this.router.navigate(['/auth']);
		}

	}

	public getFeaturedList() {
		this.listSandbox.getVendorList({ is_featured: 1 });
	}

	ngOnDestroy() {
		this.subscriptions.forEach(each => {
			each.unsubscribe();
		});
	}

}
